<template>
    <v-card tile>
        <v-card-title class="subtitle-1 font-weight-bold px-6">
            {{ translations.storeSubscriptionInfo[lang] }}
            <v-spacer></v-spacer>
            <v-btn icon @click="$emit('cancel')">
                <v-icon v-text="icons.mdiClose"></v-icon>
            </v-btn>
        </v-card-title>

        <v-divider></v-divider>
        <v-card-text class="pt-4 pb-1">
            <v-sheet
                color="rgba(234, 237, 241, 0.57)"
                outlined
                class="pa-3 mb-3"
            >
                {{
                    translations.name[lang] +
                        ": " +
                        storeSubscriptionInfo.store.name
                }}
            </v-sheet>
            <v-sheet
                color="rgba(234, 237, 241, 0.57)"
                outlined
                class="pa-3 mb-3"
            >
                {{
                    translations.storeName[lang] +
                        ": " +
                        storeSubscriptionInfo.store.app_name
                }}
            </v-sheet>
            <v-sheet
                color="rgba(234, 237, 241, 0.57)"
                outlined
                class="pa-3 mb-3"
            >
                {{
                    translations.description[lang] +
                        ": " +
                        storeSubscriptionInfo.store_subscription_plan
                            .plan_description[lang]
                }}
            </v-sheet>

            <v-sheet
                color="rgba(234, 237, 241, 0.57)"
                outlined
                class="pa-3 mb-3"
            >
                {{
                    translations.vat[lang] +
                        ": " +
                        storeSubscriptionInfo.store_subscription_plan.vat
                }}
            </v-sheet>

            <v-sheet
                color="rgba(234, 237, 241, 0.57)"
                outlined
                class="pa-3 mb-3"
            >
                {{
                    translations.email[lang] +
                        ": " +
                        storeSubscriptionInfo.store.email
                }}
            </v-sheet>

            <v-sheet
                color="rgba(234, 237, 241, 0.57)"
                outlined
                class="pa-3 mb-3"
            >
                {{
                    translations.address[lang] +
                        ": " +
                        storeSubscriptionInfo.store.address
                }}
            </v-sheet>

            <v-sheet
                color="rgba(234, 237, 241, 0.57)"
                outlined
                class="pa-3 mb-3"
            >
                {{
                    translations.primary_phone[lang] +
                        ": " +
                        storeSubscriptionInfo.store.primary_phone
                }}
            </v-sheet>

            <v-sheet
                color="rgba(234, 237, 241, 0.57)"
                outlined
                class="pa-3 mb-3"
            >
                {{ translations.paymentMethod[lang] + ": " }}
                {{
                    !storeSubscriptionInfo.store_payment_method
                        ? "-"
                        : storeSubscriptionInfo.store_payment_method
                              .system_payment_method_category.name[lang] +
                          " - " +
                          storeSubscriptionInfo.store_payment_method
                              .system_payment_method.name[lang]
                }}
            </v-sheet>

            <b-data-table
                :headers="headers"
                :items="billings"
                class="b-outlined mb-2"
                :page.sync="page"
                @page-sync="p => (page = p)"
                disable-sort
                :pagination="billingsPagination"
                
            >
                <template v-slot:item.total="{ item }">
                    {{
                        new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "EUR",
                            minimumFractionDigits: 2
                        }).format(item.total)
                    }}
                </template>
                  <template v-slot:item.period="{ item }">
                    {{
                        getPeriodString(item.period)
                    }}
                </template>

                <template v-slot:item.payment_completed="{ item }">
                    <v-alert
                        v-if="item.pending"
                        class="ma-0 text-center"
                        text
                        dense
                    >
                        {{ translations.pending[lang] }}
                    </v-alert>
                    <v-alert
                        v-else
                        :type="!['completed','failed'].includes(item.payment_status)?'warning':(item.payment_status == 'completed'&&'success'||'error')"
                        class="ma-0"
                        text
                        dense
                        outlined
                    >
                    {{ translations[item.payment_status || 'incomplete'][lang] }}
                    </v-alert>
                </template>

                <template v-slot:item.actions="{ item }" class="d-flex">
                    <v-row>
                        <v-col cols="12" md="12" class="d-flex">
                            <v-tooltip color="secondary" top>
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        icon
                                        v-on="on"
                                            v-if="!item.pending && item.payment_status != 'completed'
                                        "
                                        @click="openPayBillingDialog(item)"
                                    >
                                        <v-icon
                                            v-text="icons.mdiCreditCardOutline"
                                        ></v-icon>
                                    </v-btn>
                                </template>
                                <span class="font-weight-bold">{{
                                    translations.changeToCompleted[lang]
                                }}</span>
                            </v-tooltip>

                            <v-tooltip color="secondary" top>
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        icon
                                        v-on="on"
                                        v-if="item.invoice_status !== 'PAID' &&
                                                !item.pending"
                                        @click="openInvoiceBillingDialog(item)"
                                    >
                                        <v-icon
                                            v-text="
                                                icons.mdiReceiptTextSendOutline
                                            "
                                        ></v-icon>
                                    </v-btn>
                                </template>
                                <span class="font-weight-bold">{{
                                    translations.createInvoiceSendEmail[lang]
                                }}</span>
                            </v-tooltip>
                            <v-tooltip
                                v-if="shouldShowNotifyButton(item)"
                                color="secondary"
                                top
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        icon
                                        v-on="on"
                                        v-if="
                                            !item.payment_completed &&
                                                !item.pending
                                        "
                                        @click="openNotifyDialog(item)"
                                    >
                                        <v-icon
                                            v-text="icons.mdiMessageTextOutline"
                                        ></v-icon>
                                    </v-btn>
                                </template>
                                <span class="font-weight-bold">{{
                                    translations.notifyPayment[lang]
                                }}</span>
                            </v-tooltip>

                            <v-tooltip color="secondary" top>
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        icon
                                        v-on="on"
                                        @click="openDetailsDialog(item)"
                                    >
                                        <v-icon
                                            v-text="icons.mdiTableEye"
                                        ></v-icon>
                                    </v-btn>
                                </template>
                                <span
                                    class="font-weight-bold"
                                    v-text="translations.viewMore[lang]"
                                ></span>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                </template>
            </b-data-table>
        </v-card-text>

        <v-dialog v-model="payBillingDialog" max-width="500">
            <b-card
                v-if="payBillingDialog"
                type="accept"
                :title="translations.payBilling[lang]"
                :loading="loading"
                :error-message="errorMessage"
                :submit-text="translations.submit"
                @cancel="closePayBillingDialog()"
                @submit="changeBillingSettings({ payment: true })"
            >
                <div class="subtitle-1 font-weight-medium pl-2">
                    {{ translations.surePayBillingOf[lang] }}
                </div>
                <div class="subtitle-1 text-center font-weight-bold pl-2">
                    €{{ billing.total }}
                </div>
            </b-card>
        </v-dialog>

        <v-dialog v-model="invoiceBillingDialog" max-width="500">
            <b-card
                v-if="invoiceBillingDialog"
                type="accept"
                :title="translations.invoiceBilling[lang]"
                :loading="loading"
                :error-message="errorMessage"
                :submit-text="translations.submit"
                @cancel="closeInvoiceBillingDialog()"
                @submit="changeBillingSettings({ invoice: true })"
            >
                <div class="subtitle-1 font-weight-medium pl-2">
                    {{ translations.sureInvoiceBillingOf[lang] }}
                </div>
                <div class="subtitle-1 text-center font-weight-bold pl-2">
                    €{{ billing.total }}
                </div>
            </b-card>
        </v-dialog>

        <v-dialog v-model="notifyDialog" max-width="500">
            <b-card
                type="accept"
                :title="translations.payBilling[lang]"
                :loading="loading"
                :error-message="errorMessage"
                :submit-text="translations.submit"
                @cancel="closeNotifyDialog()"
                @submit="notifyPayment"
            >
                <div class="subtitle-1 font-weight-medium pl-2">
                    <span class="mb-5 text-subtitle-2"
                        >{{ translations.notifyManager[lang] }}:</span
                    >

                    <v-simple-table v-if="notifyItem" class="mt-3">
                        <template v-slot:default>
                            <tbody>
                                <tr>
                                    <td>{{ translations.period[lang] }}</td>
                                    <td>{{ getPeriodString(notifyItem.period) }}</td>
                                </tr>
                                <tr>
                                    <td>
                                        {{ translations.paymentStatus[lang] }}
                                    </td>
                                    <td>
                                        <v-alert
                                            type="warning"
                                            class="ma-0"
                                            text
                                            dense
                                            outlined
                                        >
                                            {{ translations.unpaid[lang] }}
                                        </v-alert>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{ translations.total[lang] }}</td>
                                    <td>€{{ notifyItem.total }}</td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </div>
            </b-card>
        </v-dialog>

        <v-dialog v-model="detailsDialog" max-width="500">
            <b-card
                :title="translations.billingDetails[lang]"
                @cancel="detailsDialog = false"
                :submitBtn="false"
            >
                <InvoiceTable
                    v-if="detailsItem"
                    :invoice="detailsItem.invoice"
                />
            </b-card>
        </v-dialog>
    </v-card>
</template>

<script>
import {
    mdiClose,
    mdiCreditCardOutline,
    mdiReceiptTextSendOutline,
    mdiMessageTextOutline,
    mdiTableEye
} from "@mdi/js";
import { mapState, mapActions } from "vuex";
import translations from "@/utils/translations/loyaltyPanel/subscriptions/stores";
import InvoiceTable from "@/components/general/settings/billingDashboard/InvoiceTable.vue";

export default {
    name: "StoreSubscriptionInfo",

    mixins: [translations],

    components: { InvoiceTable },

    data: () => ({
        icons: {
            mdiClose,
            mdiCreditCardOutline,
            mdiReceiptTextSendOutline,
            mdiMessageTextOutline,
            mdiTableEye
        },
        payBillingDialog: false,
        billing: null,
        invoiceBillingDialog: false,
        notifyDialog: false,
        notifyItem: null,
        detailsDialog: false,
        detailsItem: null,
        billings: [],
        billingsPagination: {},
        page: 1
    }),

    computed: {
        ...mapState(["loading", "errorMessage"]),

        lang() {
            return this.$route.params.lang;
        },

        storeSubscriptionInfo() {
            return this.$store.state.loyaltyPanel.subscriptions
                .storeSubscriptions.storeSubscriptionInfo;
        },

        headers() {
            return [
                {
                    text: this.translations.total[this.lang],
                    value: "total",
                    width: "20%"
                },
                {
                    text: this.translations.paymentStatus[this.lang],
                    value: "payment_completed",
                    width: "30%"
                },
                {
                    text: this.translations.period[this.lang],
                    value: "period",
                    width: "30%",
                    align: "center"
                },
                {
                    text: this.translations.actions[this.lang],
                    value: "actions",
                    width: "20%",
                    align: "center"
                }
            ];
        },

    },

    methods: {
        ...mapActions("loyaltyPanel/subscriptions/billings", [
            "updateStatus",
            "notifyBilling",
            "getBillings"
        ]),

        openPayBillingDialog(item) {
            this.billing = item;
            this.payBillingDialog = true;
        },
        openInvoiceBillingDialog(item) {
            this.billing = item;
            this.invoiceBillingDialog = true;
        },
        closePayBillingDialog() {
            this.billing = null;
            this.payBillingDialog = false;
        },
        closeInvoiceBillingDialog() {
            this.billing = null;
            this.invoiceBillingDialog = false;
        },
        openNotifyDialog(item) {
            this.notifyItem = item;
            this.notifyDialog = true;
        },
        closeNotifyDialog() {
            this.notifyItem = null;
            this.notifyDialog = false;
        },
        async notifyPayment() {
            if (this.notifyItem?.billing_id) {
                let res = await this.notifyBilling(this.notifyItem);
                if (!res.error) {
                    this.setNotification({
                        show: true,
                        type: "success",
                        text: this.translations.notificationSent[this.lang]
                    });
                }
            }
        },
        openDetailsDialog(item) {
            this.detailsDialog = true;
            this.detailsItem = item;
        },
        closeDetailsDialog() {
            this.detailsDialog = false;
            this.detailsItem = null;
        },
        async changeBillingSettings(body) {
            let res = await this.updateStatus({
                id: this.billing.billing_id,
                body
            });
            this.billing.payment_completed = res.data.payment_completed;
            this.billing.payment_status = res.data.payment_status;
            this.billing.pending = res.data.pending;
            this.billing.payment_at = res.data.payment_at;
            this.billing.invoice_status = res.data.invoice_status;
            this.closePayBillingDialog();
            this.closeInvoiceBillingDialog();
            if (res.error) {
                this.setNotification({
                    show: true,
                    type: "error",
                    text: res.message
                });
            }
        },
        shouldShowNotifyButton(item) {
            if(this.storeSubscriptionInfo.store_payment_method?.system_payment_method_category
            ?.system == "payment_codes" ) {
                return ['incomplete', 'failed'].includes(item.payment_status || 'incomplete');
            }
            return false
        },

        async fetchBillings() {
            let id = this.storeSubscriptionInfo.store_subscription_id
            let page = this.page
            if (page && id) {
                let res = await this.getBillings({id, page})
                if (res?.data) {
                    this.billings = res.data.billings
                    this.billingsPagination = res.data.pagination
                }
            }
        },
        getPeriodString(period) {
            if (!period) return '-';
            let start = new Date(period.from);
            let end = new Date(period.to);
            return `${start.toLocaleDateString(this.lang)} - ${end.toLocaleDateString(this.lang)}`;
        }
    },

    watch: {
        ["storeSubscriptionInfo.store_subscription_id"]: {
            immediate: true,
            async handler(val) {
                this.page = 1
                this.fetchBillings()
            } 
        },


        page: {
            async handler(page) {
                if (this.billings || page > 1) {
                    this.fetchBillings()
                }
            },
        }
    }
};
</script>
